export const validateUrl = (text?: string | null): boolean => {
  let url: URL;

  try {
    url = new URL(text as string);
  } catch (_) {
    return false;
  }

  // "http" is unsafe
  const isValid: boolean = Boolean(url.protocol === 'https:');

  return isValid;
};

export const validateEmail = (email?: string | null): boolean => {
  if (!email) return false;

  const re: RegExp = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return re.test(email);
};

export const validateDueDate = (dueDate: string): boolean | string => {
  const dueDateAsDate = new Date(dueDate);
  const currentDate = new Date();

  if (dueDateAsDate < currentDate) {
    return 'Due date must be in the future';
  }

  return true;
};

export const getValidYearNumber = (
  year?: string | number,
): number | undefined => {
  const yearNumber: number = Number(year);
  const isValidYear: boolean = Boolean(yearNumber && !Number.isNaN(year));

  return isValidYear ? Number(year) : undefined;
};

export const isSameOriginUrl = (url?: string | null): boolean => {
  if (!url) return false;

  if (typeof window === 'undefined') return false;

  if (url.startsWith('/')) {
    return true;
  }

  try {
    const targetUrl = new URL(url);
    const currentOrigin = window.location.origin;

    return targetUrl.origin === currentOrigin;
  } catch (_) {
    return false;
  }
};
